/* Zemits CTA bridge: Tilda-форми -> Shopify /contact ліди (CTA audit 2026-09-05) */
(function(){
  function esc(s){return String(s||'').replace(/[&<>"']/g,function(c){return{'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c];});}
  function findVal(form, keys, types){
    var els = form.querySelectorAll('input,select,textarea');
    for (var i=0;i<els.length;i++){
      var el = els[i], n = ((el.name||'')+' '+(el.id||'')+' '+(el.placeholder||'')).toLowerCase();
      if ((el.type==='checkbox'||el.type==='radio') && !el.checked) continue;
      for (var k=0;k<keys.length;k++){
        if (n.indexOf(keys[k])>-1 && el.value && el.value.trim()){
          if (types && types.indexOf(el.type)===-1) continue;
          return el.value.trim();
        }
      }
    }
    return '';
  }
  function collect(form){
    var formName=(form.querySelector('[name="tildaspec-formname"]')||{}).value||'';
    var rows=[];
    var els=form.querySelectorAll('input,select,textarea');
    for (var i=0;i<els.length;i++){
      var el=els[i]; if(!el.value||!el.value.trim())continue;
      if(el.type==='checkbox'||el.type==='radio'){if(!el.checked)continue;}
      if(el.type==='hidden'||el.type==='submit'||el.type==='button')continue;
      rows.push(esc(el.name||el.placeholder||el.type)+': '+esc(el.value.trim()));
    }
    return {formName:formName, rows:rows};
  }
  function success(form, msg){
    var wrap=document.createElement('div');
    wrap.className='zh-lead-ok';
    wrap.style.cssText='padding:28px 24px;border:1px solid #d4f0d4;border-radius:12px;background:#f2fbf2;color:#1d6b1d;font-size:16px;line-height:1.5;text-align:center';
    wrap.innerHTML='<div style="font-size:34px;margin-bottom:10px">&#10003;</div>'+esc(msg||'Thank you! Your request has been sent. Our manager will contact you shortly.');
    form.style.display='none';
    if(form.parentNode)form.parentNode.insertBefore(wrap,form);
  }
  function nativePost(name,email,body){
    var f=document.createElement('form');f.method='POST';f.action='/contact';f.style.display='none';
    function add(n,v){var i=document.createElement('input');i.type='hidden';i.name=n;i.value=v;f.appendChild(i);}
    add('form_type','contact');add('utf8','\u2713');add('return_to',location.pathname);
    add('contact[name]',name);add('contact[email]',email);add('contact[body]',body);
    document.body.appendChild(f);f.submit();
  }
  document.addEventListener('submit', function(e){
    var form=e.target;
    if(!(form&&form.classList&&(form.classList.contains('t-form')||form.classList.contains('js-form-proccess'))))return;
    e.preventDefault();e.stopPropagation();
    var name=findVal(form,['name','ім\'я','your name'])||'Website Lead';
    var email=findVal(form,['email','e-mail'],['email','text'])||'';
    var phone=findVal(form,['phone','tel','телефон']);
    var c=collect(form);
    var body=(c.formName?('Form: '+esc(c.formName)+'\n'):'')+(phone?('Phone: '+esc(phone)+'\n'):'')+'Page: '+esc(location.href)+'\n\n'+c.rows.join('\n');
    var email2=email||'no-reply@zemits-official.myshopify.com';
    var params=new URLSearchParams();
    params.append('form_type','contact');params.append('utf8','\u2713');params.append('return_to',location.pathname);
    params.append('contact[name]',name);params.append('contact[email]',email2);params.append('contact[body]',body);
    fetch('/contact',{method:'POST',headers:{'Content-Type':'application/x-www-form-urlencoded'},credentials:'same-origin',body:params.toString(),redirect:'follow'})
      .then(function(r){return r.text().then(function(t){return {ok:r.ok,url:r.url,t:t};});})
      .then(function(res){
        if(res.ok){success(form);}
        else{nativePost(name,email2,body);}   /* fallback: навігаційний POST — лід все одно доставляється */
      })
      .catch(function(){nativePost(name,email2,body);});
  }, true);

  /* success banner after native fallback redirect */
  if (location.search.indexOf('contact_posted=true') > -1) {
    var b = document.createElement('div');
    b.className = 'zh-lead-ok zh-lead-banner';
    b.style.cssText = 'position:sticky;top:0;z-index:99999;padding:18px 24px;border:1px solid #d4f0d4;background:#f2fbf2;color:#1d6b1d;font-size:16px;text-align:center';
    b.innerHTML = '<span style="font-size:20px;margin-right:8px">&#10003;</span>Thank you! Your request has been sent. Our manager will contact you shortly.';
    document.body && document.body.insertBefore(b, document.body.firstChild);
    try { history.replaceState(null, '', location.pathname); } catch(err) {}
  }

})();
